import { useState, useEffect } from "react";
import { api } from "./api";

// Sticky per-user height unit preference (cm | ft). Persisted on the ACCOUNT
// (survives cache/cookie clears) with a localStorage mirror + window event to
// sync all components/pages instantly.
const KEY = "rosterly_height_unit";
const EVT = "rosterly-height-unit";

export const getHeightUnit = () => {
    if (typeof window === "undefined") return "cm";
    return window.localStorage.getItem(KEY) === "ft" ? "ft" : "cm";
};

export function useHeightUnit() {
    const [unit, setUnitState] = useState(getHeightUnit);
    useEffect(() => {
        const on = () => setUnitState(getHeightUnit());
        window.addEventListener(EVT, on);
        window.addEventListener("storage", on);
        return () => { window.removeEventListener(EVT, on); window.removeEventListener("storage", on); };
    }, []);
    const setUnit = (u) => {
        const v = u === "ft" ? "ft" : "cm";
        window.localStorage.setItem(KEY, v);
        window.dispatchEvent(new Event(EVT));
        setUnitState(v);
        api.put("/account", { height_unit: v }).catch(() => {});
    };
    return [unit, setUnit];
}

// cm → "5'9"" (rounds total inches FIRST so 182cm never renders as 5'12").
export const cmToFtIn = (cm) => {
    const n = Number(cm) || 0;
    if (n <= 0) return "";
    const totalIn = Math.round(n / 2.54);
    return `${Math.floor(totalIn / 12)}'${totalIn % 12}"`;
};

export const formatHeight = (cm, unit) => {
    const n = Number(cm) || 0;
    if (n <= 0) return "—";
    return unit === "ft" ? cmToFtIn(n) : `${n} cm`;
};
